/**
 * @fileoverview Centralized configuration for environment variables
 * @description This file exports all environment variables as named constants
 * for use throughout the application. This provides a single source of truth
 * for all configuration values.
 */

/**
 * API Configuration
 * @constant {string} API_URL - Base URL for the backend API
 */
export const API_URL = process.env.REACT_APP_API_URL;

/**
 * Socket.IO Configuration
 * @constant {string} SOCKET_URL - Base URL for Socket.IO connections
 * @description Extracts the socket URL by removing /api suffix from API URL
 */
export const SOCKET_URL = process.env.REACT_APP_API_URL?.replace(
  /\/api$/,  // Remove /api from the END of the URL
  ""
) || process.env.REACT_APP_API_URL;

